<app-loading *ngIf="!contentReady"></app-loading>

<div
  class="container mb-4"
  style="margin-top: 10px;"
  *ngIf="contentReady"
  dir="rtl"
>
  <div class="row additem-content">
    <br />
    <br />

    <h2 class="additemhead">
      بيانات تسجيل طبيب الأسنان
    </h2>

    <div class="text-center mb-4" *ngIf="data?.doctor_image_url || data?.doctor_image">
      <img
        [src]="data?.doctor_image_url || getStorageUrl(data?.doctor_image)"
        width="120"
        height="120"
        style="
          border-radius:50%;
          object-fit:cover;
          border:3px solid #e3e3e3;
          box-shadow:0 4px 10px rgba(0,0,0,0.1);
        "
        alt="Doctor Image"
      />
    </div>

    <div class="form">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <table class="table table-bordered align-middle">
            <tbody>

              <!-- Basic Data -->
              <tr>
                <th>الاسم بالكامل</th>
                <td>{{ data?.full_name || '—' }}</td>
              </tr>

              <tr>
                <th>تاريخ الميلاد</th>
                <td>
                  {{ data?.date_of_birth ? (data?.date_of_birth | date:'yyyy-MM-dd') : '—' }}
                </td>
              </tr>

              <tr>
                <th>النوع</th>
                <td>
                  {{
                    data?.gender === 'male'
                      ? 'ذكر'
                      : data?.gender === 'female'
                        ? 'أنثى'
                        : '—'
                  }}
                </td>
              </tr>

              <tr>
                <th>رقم الموبايل</th>
                <td>{{ data?.mobile || '—' }}</td>
              </tr>

              <tr>
                <th>رقم الواتساب</th>
                <td>{{ data?.whatsapp_number || '—' }}</td>
              </tr>

              <tr>
                <th>البريد الإلكتروني</th>
                <td>{{ data?.email || '—' }}</td>
              </tr>

              <!-- Specialty -->
              <tr>
                <th>التخصص</th>
                <td>
                  {{ data?.specialty || '—' }}
                  <span *ngIf="data?.specialty === 'Other' && data?.specialty_other">
                    – {{ data?.specialty_other }}
                  </span>
                </td>
              </tr>

              <tr>
                <th>أعلى مؤهل علمي</th>
                <td>
                  {{ data?.highest_qualification || '—' }}
                  <span *ngIf="data?.highest_qualification === 'Other' && data?.qualification_other">
                    – {{ data?.qualification_other }}
                  </span>
                </td>
              </tr>

              <!-- Additional Certificates Text -->
              <tr>
                <th>شهادات إضافية</th>
                <td>
                  <span *ngIf="data?.has_additional_certificates && selectedCertificates.length; else noCert">
                    {{ selectedCertificates.join(' ، ') }}
                  </span>

                  <span *ngIf="data?.additional_certificates_other">
                    <br />
                    أخرى: {{ data?.additional_certificates_other }}
                  </span>

                  <ng-template #noCert>لا يوجد</ng-template>
                </td>
              </tr>

              <!-- Uploaded Certificates Files -->
              <tr>
                <th>ملفات الشهادات المرفوعة</th>
                <td>
                  <div *ngIf="uploadedCertificates.length; else noUploadedCerts">
                    <div
                      class="certificate-item mb-2 p-2 border rounded"
                      *ngFor="let cert of uploadedCertificates; let i = index; trackBy: trackByCertificate"
                    >
                      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">

                        <div class="d-flex align-items-center gap-2">
                          <ng-container *ngIf="isImageCertificate(cert); else pdfIcon">
                            <img
                              [src]="getCertificateUrl(cert)"
                              width="55"
                              height="55"
                              style="object-fit:cover;border-radius:8px;border:1px solid #ddd;"
                              alt="Certificate"
                            />
                          </ng-container>

                          <ng-template #pdfIcon>
                            <span
                              style="
                                display:inline-flex;
                                align-items:center;
                                justify-content:center;
                                width:55px;
                                height:55px;
                                border-radius:8px;
                                background:#f2f2f2;
                                border:1px solid #ddd;
                                font-weight:700;
                              "
                            >
                              PDF
                            </span>
                          </ng-template>

                          <div>
                            <strong>
                              {{ getCertificateName(cert, i) }}
                            </strong>

                            <div style="font-size: 13px; color:#666;">
                              {{ getCertificateTypeLabel(cert) }}
                              <span *ngIf="cert?.size">
                                - {{ formatFileSize(cert?.size) }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <a
                          class="btn btn-sm btn-outline-primary"
                          [href]="getCertificateUrl(cert)"
                          target="_blank"
                          rel="noopener"
                        >
                          فتح الملف
                        </a>
                      </div>
                    </div>
                  </div>

                  <ng-template #noUploadedCerts>
                    لا يوجد ملفات شهادات مرفوعة
                  </ng-template>
                </td>
              </tr>

              <!-- SCFHS -->
              <tr>
                <th>حالة تصنيف SCFHS</th>
                <td>{{ scfhsStatusLabel(data?.scfhs_status) }}</td>
              </tr>

              <tr *ngIf="data?.scfhs_status && data?.scfhs_status !== 'no'">
                <th>مستوى التصنيف</th>
                <td>{{ scfhsLevelLabel(data?.scfhs_classification_level) }}</td>
              </tr>

              <tr *ngIf="data?.scfhs_status && data?.scfhs_status !== 'no'">
                <th>تاريخ التصنيف</th>
                <td>
                  {{
                    data?.scfhs_classification_date
                      ? (data?.scfhs_classification_date | date:'yyyy-MM-dd')
                      : '—'
                  }}
                </td>
              </tr>

              <!-- Years -->
              <tr>
                <th>سنوات الخبرة بعد المؤهل</th>
                <td>{{ yearsLabel(data?.years_of_practice) }}</td>
              </tr>

              <tr>
                <th>سنة الماجستير</th>
                <td>{{ data?.master_year || '—' }}</td>
              </tr>

              <tr>
                <th>سنة الدكتوراه</th>
                <td>{{ data?.phd_year || '—' }}</td>
              </tr>

              <!-- Employment -->
              <tr>
                <th>نوع التوظيف المفضل</th>
                <td>{{ employmentLabel(data?.preferred_employment_type) }}</td>
              </tr>

              <tr *ngIf="isSurgerySpecialty()">
                <th>بيئة العمل المفضلة</th>
                <td>{{ practiceEnvLabel(data?.preferred_practice_environment) }}</td>
              </tr>

              <!-- CV / Portfolio -->
              <tr>
                <th>السيرة الذاتية</th>
                <td>
                  <a
                    *ngIf="data?.cv_pdf; else noCv"
                    [href]="getStorageUrl(data?.cv_pdf)"
                    target="_blank"
                    rel="noopener"
                    class="btn btn-sm btn-outline-primary"
                  >
                    فتح السيرة الذاتية
                  </a>

                  <ng-template #noCv>لا يوجد</ng-template>
                </td>
              </tr>

              <tr>
                <th>Portfolio</th>
                <td>
                  <a
                    *ngIf="data?.portfolio_link; else noPortfolio"
                    [href]="data?.portfolio_link"
                    target="_blank"
                    rel="noopener"
                  >
                    {{ data?.portfolio_link }}
                  </a>

                  <ng-template #noPortfolio>—</ng-template>
                </td>
              </tr>

              <!-- Scoring -->
              <tr class="table-secondary">
                <th>سكور التصنيف</th>
                <td>{{ data?.scfhs_classification_score ?? '—' }}</td>
              </tr>

              <tr class="table-secondary">
                <th>سكور الخبرة</th>
                <td>{{ data?.years_of_practice_score ?? '—' }}</td>
              </tr>

              <tr class="table-secondary">
                <th>سكور حالة التسجيل</th>
                <td>{{ data?.scfhs_status_score ?? '—' }}</td>
              </tr>

              <tr class="table-secondary">
                <th>سكور نوع التوظيف</th>
                <td>{{ data?.employment_preference_score ?? '—' }}</td>
              </tr>

              <tr class="table-primary">
                <th>إجمالي النقاط</th>
                <td>
                  <strong>{{ data?.total_score ?? '—' }}</strong>
                </td>
              </tr>

              <tr>
                <th>التقييم النهائي</th>
                <td>
                  <span
                    class="badge"
                    [ngClass]="{
                      'bg-success': data?.interpretation_band === 'priority_shortlist',
                      'bg-warning': data?.interpretation_band === 'hold_further_review',
                      'bg-danger': data?.interpretation_band === 'not_suitable'
                    }"
                  >
                    {{ interpretationLabel(data?.interpretation_band) }}
                  </span>
                </td>
              </tr>

              <tr>
                <th>ملاحظات إضافية</th>
                <td>{{ data?.additional_notes || '—' }}</td>
              </tr>

            </tbody>
          </table>

          <div class="text-center mt-3" *ngIf="canEdit">
            <button type="button" class="btn btn-primary" (click)="edit()">
              تعديل البيانات
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
